var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.86 8.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #0b5ed6;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: .3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.36,6.35c-1.3,0-2.35-1.06-2.35-2.35s1.06-2.35,2.35-2.35,2.35,1.06,2.35,2.35-1.06,2.35-2.35,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.1,6.86c-.68.56-1.46,1-2.32,1.3-.02,0-.04.01-.06.01s-.04,0-.06-.01c-1.22-.43-2.31-1.15-3.14-2.09-.75-.85-1.23-1.81-1.34-2.71-.12-.89.13-1.79.67-2.39C1.31.43,1.95.15,2.68.15c1.11,0,1.65.58,2.04,1.11.4-.54.93-1.11,2.04-1.11,1.03,0,1.89.59,2.3,1.57"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.7,5.55h-.69c-.11,0-.19-.09-.19-.19v-.73h-.73c-.11,0-.19-.09-.19-.19v-.69c0-.11.09-.19.19-.19h.73v-.73c0-.11.09-.19.19-.19h.69c.11,0,.19.09.19.19v.73h.73c.11,0,.19.09.19.19v.69c0,.11-.09.19-.19.19h-.73v.73c0,.11-.09.19-.19.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/Icon 12.cbf3cd817ab73101df5f99cd3d0ceac2.svg";
export { ForwardRef as ReactComponent };